import { takeLatest, select, put, cancel } from 'redux-saga/effects';

import {
  validateAppointment,
  validateAppointmentByDate,
} from '../../../utils/dashboard/validateAppointmentByFilter';
import { selectDashboardNotEmptyFilterState } from '../selectors';
import * as appointmentList from '../requests/appointment-list-req';
import * as wsActions from '../real-time-updates';

const actionsMap = {
  [wsActions.consts.CHANGE_STATUS]: {
    action: appointmentList.actions.updateViaWs,
    validate: validateAppointmentByDate,
  },
  [wsActions.consts.CHANGE_PAYMENT_STATUS]: {
    action: appointmentList.actions.updateViaWs,
    validate: validateAppointmentByDate,
  },
  [wsActions.consts.UPDATE_COPAY]: {
    action: appointmentList.actions.updateViaWs,
    validate: validateAppointment,
  },
  [wsActions.consts.CHANGE_ROOM]: {
    action: appointmentList.actions.updateViaWs,
    validate: validateAppointment,
  },
  [wsActions.consts.PIN]: {
    action: appointmentList.actions.pinViaWs,
    validate: validateAppointment,
  },
  [wsActions.consts.REMOVE_FROM_DASHBOARD]: {
    action: appointmentList.actions.removeItem,
    validate: validateAppointment,
  },
};

function* handleRealTimeUpdate({ type, payload }) {
  const filterOptions = yield select(selectDashboardNotEmptyFilterState);
  const { action, validate } = actionsMap[type];
  const fitFilter = validate(payload, filterOptions);

  if (!fitFilter) yield cancel();

  yield put(action(payload));
}

export default function* realTimeUpdate() {
  yield takeLatest(
    [
      wsActions.consts.REMOVE_FROM_DASHBOARD,
      wsActions.consts.CHANGE_PAYMENT_STATUS,
      wsActions.consts.UPDATE_COPAY,
      wsActions.consts.CHANGE_STATUS,
      wsActions.consts.CHANGE_ROOM,
      wsActions.consts.PIN,
    ],
    handleRealTimeUpdate,
  );
}



// WEBPACK FOOTER //
// ./src/redux/dashboard/sagas/real-time-update.js